/**
 * Discovery API client — Category → Product → Nearest Stores flow.
 */
import client from './client';

export interface NearbyStore {
  id: number;
  business_name: string;
  distance_km: number;
  rating: number;
  is_open: boolean;
  delivery_fee: number;
  address?: string | null;
  city?: string | null;
  logo_url?: string | null;
  cover_photo_url?: string | null;
  estimated_minutes?: number | null;
}

export interface SearchProductHit {
  id: number;
  name: string;
  image_url?: string | null;
  price: number;
  mrp?: number | null;
  unit?: string | null;
  category?: string | null;
  store_id: number;
  store_name?: string | null;
}

export interface SearchStoreHit {
  id: number;
  business_name: string;
  address?: string | null;
  city?: string | null;
  logo_url?: string | null;
  rating: number;
  is_open: boolean;
  distance_km?: number | null;
}

export interface SearchMenuItemHit {
  id: number;
  name: string;
  image_url?: string | null;
  price: number;
  is_veg: boolean;
  store_id: number;
  store_name?: string | null;
  category_name?: string | null;
}

export interface GlobalSearchResponse {
  query: string;
  products: SearchProductHit[];
  stores: SearchStoreHit[];
  menu_items: SearchMenuItemHit[];
}

export const discoveryAPI = {
  /** Stores carrying a particular product, sorted by distance. */
  async nearbyStoresForProduct(params: {
    productId?: number;
    lat: number;
    lng: number;
    radiusKm?: number;
    openOnly?: boolean;
    limit?: number;
  }): Promise<NearbyStore[]> {
    const res = await client.get<NearbyStore[]>('/api/stores/nearby', {
      params: {
        lat: params.lat,
        lng: params.lng,
        radius_km: params.radiusKm ?? 10,
        product_id: params.productId,
        open_only: params.openOnly,
        limit: params.limit ?? 50,
      },
    });
    return res.data;
  },

  /** Unified search across products and stores. */
  async search(params: { q: string; lat?: number; lng?: number; limit?: number }): Promise<GlobalSearchResponse> {
    const res = await client.get<GlobalSearchResponse>('/api/search', {
      params: { q: params.q, lat: params.lat, lng: params.lng, limit: params.limit ?? 8 },
    });
    return res.data;
  },
};

